import React, { FC, useEffect, useState } from "react";
import FilterCategoryTitle from "../filterCategoryTitle";

import useSearch from "../../hooks/useSearch";
import { PickerValue } from "../../types";

type Props = {
  label: string;
  values: Array<PickerValue>;
  placeholderId?: string;
  isVertical?: boolean;
  defaultSelected?: number[];
  onChange?: (id: number[]) => void;
};
const FilterCheckboxes: FC<Props> = ({
  label,
  values,
  placeholderId,
  isVertical = false,
  defaultSelected = [],
  onChange,
}) => {
  const [selected, setSelected] = useState<number[]>(defaultSelected);
  const { setFilteredSearch } = useSearch();

  useEffect(() => {
    if (placeholderId) {
      setFilteredSearch({
        [placeholderId]: selected.length > 0 ? selected : ["-2"],
      });
    }
    if (onChange) onChange(selected);
  }, [selected]);

  const handleCheckedBoxes = (value: { id: number }) => {
    setSelected((prev) => {
      const uniqueValues = new Set(prev.map((x) => +x));
      if (uniqueValues.has(+value.id)) {
        uniqueValues.delete(+value.id);
      } else {
        uniqueValues.add(+value.id);
      }
      return Array.from(uniqueValues);
    });
  };

  return (
    <div
      className={`FilterCheckboxes flex flex-col ${
        !isVertical && "md:flex-row md:space-x-2"
      }`}
    >
      <div className={`overflow-hidden h-7 ${!isVertical && "md:min-w-fit"}`}>
        <FilterCategoryTitle title={label} />
      </div>
      <fieldset
        className={`w-full max-w-3xl space-y-2.5 ${
          !isVertical && "md:flex md:flex-wrap md:items-center md:space-y-0"
        }`}
      >
        <legend className="sr-only">{label}</legend>
        {values.map((value) => (
          <div
            key={value.id}
            className={`relative flex items-start ${!isVertical && "md:w-1/3"}`}
          >
            <div className="flex items-center shrink-0">
              <input
                id={value.id.toString()}
                checked={selected.find((x) => x == value.id) ? true : false}
                onChange={() => {}}
                onClick={() => handleCheckedBoxes({ id: +value.id })}
                aria-describedby="comments-description"
                name={value.name}
                type="checkbox"
                className={`accent-custom-blue h-[26px] w-[26px] text-custom-blue border-gray-300 rounded mb-0 ${
                  !isVertical && "md:mb-2.5"
                }`}
              />
            </div>
            <div className="ml-2 text-base flex shrink grow item">
              <label
                htmlFor={value.id.toString()}
                className="font-base text-custom-black shrink flex grow text-left"
              >
                {value.name}
              </label>
            </div>
          </div>
        ))}
      </fieldset>
    </div>
  );
};

export default FilterCheckboxes;
